import { apiFetch } from "./client";
import { ELEVENLABS_AGENT_ID, ELEVENLABS_TOKEN_PATH } from "../voice/elevenlabsConfig";

export type ConversationTokenResult =
  | { ok: true; token: string; configured: true }
  | { ok: false; configured: boolean; error: string };

export async function fetchConversationToken(
  agentId: string = ELEVENLABS_AGENT_ID
): Promise<ConversationTokenResult> {
  const qs = agentId ? `?agent_id=${encodeURIComponent(agentId)}` : "";
  const res = await apiFetch<{
    token?: string;
    configured?: boolean;
    error?: string;
  }>(`${ELEVENLABS_TOKEN_PATH}${qs}`);

  if (!res.ok) {
    const configured = res.status !== 503;
    return {
      ok: false,
      configured,
      error: res.error || "Could not reach voice assistant",
    };
  }

  const token = res.data?.token;
  if (!token) {
    return {
      ok: false,
      configured: Boolean(res.data?.configured ?? true),
      error: "Token missing in server response",
    };
  }

  return { ok: true, token, configured: true };
}
